import { useCallback, useMemo, memo } from 'react';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useTableDispatch, useTableSelector } from '../../redux/reduxHooks';
import { makeGetIsRowSelected, setRowsSelected } from '../redux/selectionSlice';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectRowCheckboxCell = ({
  rowId
}) => {
  const getIsRowSelected = useMemo(() => makeGetIsRowSelected(rowId), [rowId]);
  const isSelected = useTableSelector(getIsRowSelected);
  const dispatch = useTableDispatch();
  const handleChange = useCallback(({
    target: {
      checked
    }
  }) => dispatch(setRowsSelected([{
    rowId,
    selected: checked
  }])), [dispatch, rowId]);
  return /*#__PURE__*/_jsx("td", {
    "data-selection-column": true,
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "100%",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(Checkbox, {
        "aria-label": I18n.text('datatable.selectRowCheckbox.ariaLabel'),
        "data-test-id": `checkbox-select-row-${rowId}`,
        checked: isSelected,
        onChange: handleChange
      })
    })
  });
};
export default /*#__PURE__*/memo(SelectRowCheckboxCell);